import React, { useState, useEffect } from "react";
import {
  readTransactionFromWallet,
  getEnrollmentIdFromWallet,
} from "../extensionMethods/app";
import Modal from "react-bootstrap/Modal";
import { Button, TextField, Box, Typography } from "@mui/material";
import config from "../config";
import { DAPP_NAME, TransactionName, DAPP_ICON } from "../constants";
import { ExecuteReadTransaction, formattedErrorMessage } from "../utils";
import BigNumber from "bignumber.js";

// Modal Component
function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          position: "relative",
        }}
      >
        {/* Close button positioned at the top-right of the modal body */}
        <Button
          onClick={props.onHide}
          style={{
            position: "absolute",
            top: "-7px",
            right: "-16px",
            background: "none",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            color: "#000",
          }}
        >
          ✕
        </Button>

        {/* Balance Display with Dynamic Font Sizing */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            fontSize: "clamp(16px, 5vw, 30px)", // Dynamically scales font size
            marginBottom: "10px",
            textAlign: "center",
            whiteSpace: "nowrap", // Prevents wrapping
            overflow: "hidden", // Hides overflowing content
            textOverflow: "ellipsis", // Adds ellipsis if needed
          }}
        >
          {props.balance}
        </Typography>

        {/* Account Balance Text */}
        <Typography
          variant="body2"
          sx={{
            color: "#7a7a7a",
            fontSize: "clamp(10px, 2vw, 16px)", // Dynamically adjusts font size
            textAlign: "center",
          }}
        >
          Account Balance
        </Typography>
      </Modal.Body>
    </Modal>
  );
}

// Main Component
const GetBalance = ({ address }) => {
  const [vendorAddress, setVendorAddress] = useState(address);
  const [balance, setBalance] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [enrollmentId, setEnrollmentId] = useState("");

  // Fetch enrollmentId on component mount
  // useEffect(() => {
  //   const fetchEnrollmentId = async () => {
  //     try {
  //       const dappToken = localStorage.getItem("opensea_dappToken") || "";
  //       console.log("DappToken retrieved:", dappToken); // Log the dappToken

  //       if (!dappToken) {
  //         console.error("Error: No dappToken exists in localStorage");
  //         return; // Exit if no dappToken
  //       }

  //       // Attempt to fetch the enrollmentId
  //       const res = await getEnrollmentIdFromWallet(
  //         dappToken,
  //         DAPP_NAME,
  //         DAPP_URL,
  //         DAPP_ICON
  //       );

  //       console.log("Enrollment ID fetched from wallet (raw response):", res); // Log the full response

  //       // Handle and log the case when the response is empty or undefined
  //       if (!res || res === '') {
  //         console.error("Error: Enrollment ID is empty or undefined. Check if the wallet is properly configured.");
  //         return; // Exit early if the result is empty
  //       }

  //       // Set the enrollmentId and vendorAddress if the response is valid
  //       setEnrollmentId(res);
  //       setVendorAddress(res);
  //       localStorage.setItem("opensea_enrollmentId", res); // Save it to localStorage
  //     } catch (error) {
  //       console.error("Error fetching enrollmentId:", error); // Log the error in detail
  //     }
  //   };

  //   fetchEnrollmentId();
  // }, []); // Empty dependency array to run only once on mount

  // Log vendorAddress to verify the auto-population
  useEffect(() => {
    console.log("Updated vendorAddress:", vendorAddress); // Log whenever vendorAddress changes
  }, [vendorAddress]); // Runs when vendorAddress changes

  const handleSubmit = () => {
    getBalance();
  };

  const handleAddress = async () => {
    const dappToken = localStorage.getItem("opensea_dappToken") || "";
    await getEnrollmentIdFromWallet(
      dappToken,
      DAPP_NAME,
      config.DAPP_URL,
      DAPP_ICON
    );
  };

  const getBalance = async () => {
    try {
      const transactionParams = [vendorAddress];

      const [res, errMsg] = await ExecuteReadTransaction(
        config.CHANNEL_NAME,
        config.CHAINCODE_NAME,
        TransactionName.BALANCE,
        transactionParams
      );
      if (res) {
        setBalance(new BigNumber(res?.response).dividedBy(100)); // Set the balance
        setModalShow(true); // Show modal when balance is retrieved
      } else {
        throw new Error(formattedErrorMessage(errMsg));
      }
    } catch (error) {
      console.error("Error in getBalance:", error);
    }
  };

  return (
    <Box
      sx={{
        padding: "40px",
        maxWidth: "500px",
        width: "100%",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", marginBottom: "20px" }}
      >
        Check Balance
      </Typography>

      <TextField
        placeholder="Enter Wallet Address"
        variant="outlined"
        fullWidth
        value={vendorAddress} // Reflects the auto-populated vendorAddress
        onChange={(e) => setVendorAddress(e.target.value.toLowerCase())} // Allow manual input if needed
        sx={{
          textTransform: "lowercase",
          backgroundColor: "white",
          borderRadius: "8px",
          marginBottom: "20px",
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
        }}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={handleSubmit}
        disabled={!vendorAddress || vendorAddress?.length !== 40}
        sx={{
          backgroundColor: "#0055FF",
          color: "#fff",
          padding: "10px 0",
          fontWeight: "bold",
          fontSize: "16px",
          borderRadius: "10px",
          textTransform: "none",
          "&:hover": {
            backgroundColor: "#0044CC",
          },
        }}
      >
        Get Balance
      </Button>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        balance={new BigNumber(balance).toFormat(2)} // Pass the balance as a prop to the modal
      />
    </Box>
  );
};

export default GetBalance;
